import Vue from 'vue'

Vue.filter('formatMinute', value => {

    if (value === null || value === '') return 'None'

    return (Math.floor(parseInt(value) / 60)).toString() + ' minutes'

})